import React, { useEffect } from "react";
import AccountDetailsOnboardingForm from "./AccountDetailsOnboardingForm";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function AccountDetailsOnboardingStep({
  onComplete,
  onBack,
}: {
  onComplete: () => void;
  onBack?: () => void;
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {onBack && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          className="mb-4 -ml-2"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
      )}
      <AccountDetailsOnboardingForm onComplete={onComplete} />
    </div>
  );
}
